import merge from 'lodash/merge';
import transform from '../transform';
import { FEATURE_FLAG_OVERRIDES } from './constants';
import {
    LOCALE_WITH_VERSION_2,
    PACKAGE_ONE,
    PACKAGE_VERSION_1,
} from '../../constants/main';

/**
 * Some sections in packages change according to the country and
 * a FF condition. This function merges conditional sections
 * for packages, depending on locale and feature flag
 *
 * @param  {object} settings default settings for the page
 * @param  {bool} featureFlag if enabled, changes will be merged with default settings
 * @return {object} newly transformed settings with all of the settings merged
 */
export const packageSectionsTransform = (settings, featureFlag = false) => {
    const { locale, page, userPlan, packageVersion } = settings;
    const transformSettings = transform(settings);

    if (
        featureFlag &&
        LOCALE_WITH_VERSION_2.includes(locale) &&
        FEATURE_FLAG_OVERRIDES[locale] &&
        FEATURE_FLAG_OVERRIDES[locale][page]
    ) {
        transformSettings['sections'] = merge(
            transformSettings['sections'],
            FEATURE_FLAG_OVERRIDES[locale][page]['sections'],
        );
        if (userPlan === PACKAGE_ONE && packageVersion === PACKAGE_VERSION_1) {
            transformSettings['CTAs'] =
                FEATURE_FLAG_OVERRIDES[locale][page]['CTAs'];
            transformSettings['CTAStyles'] =
                FEATURE_FLAG_OVERRIDES[locale][page]['CTAStyles'];
        }
    }

    return transformSettings;
};
